import React, { useContext, useState, useEffect } from "react";
import { auth, firebaseAuth } from "../firebase";
import { useNavigate } from "react-router-dom";

import { db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const navigate = useNavigate();

  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  function signup(email, password) {
    return auth.createUserWithEmailAndPassword(email, password);
  }

  function login(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
  }

  function logout() {
    return auth.signOut();
  }

  function resetPassword(email) {
    return auth.sendPasswordResetEmail(email);
  }

  function updateEmail(email) {
    return currentUser.updateEmail(email);
  }

  function updatePassword(password) {
    return currentUser.updatePassword(password);
  }

  function continueWithGoogle() {
    const googleProvider = new firebaseAuth.GoogleAuthProvider();

    auth
      .signInWithPopup(googleProvider)
      .then(async (res) => {
        const { user } = res;

        await setDoc(
          doc(db, "users", user.uid),
          {
            displayName: res.user.displayName,
          },
          { merge: true }
        );

        navigate("/");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function continueWithTwitter() {
    const twitterProvider = new firebaseAuth.TwitterAuthProvider();

    auth
      .signInWithPopup(twitterProvider)
      .then(async (res) => {
        const { user } = res;

        await setDoc(
          doc(db, "users", user.uid),
          {
            displayName: res.user.displayName,
          },
          { merge: true }
        );

        navigate("/");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const value = {
    currentUser,
    signup,
    login,
    logout,
    resetPassword,
    updateEmail,
    updatePassword,
    continueWithGoogle,
    continueWithTwitter,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
